module.exports = __webpack_public_path__ + "onboarding-feed-maven.1b843658cbf4b5af2839b0ddccb886bc.hashedasset.svg";